/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Field_Invoice_DateInputs */

const en_inbound_field_invoice_date = /** @type {(inputs: Inbound_Field_Invoice_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice date`)
};

/**
* | output |
* | --- |
* | "Invoice date" |
*
* @param {Inbound_Field_Invoice_DateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_field_invoice_date = /** @type {((inputs?: Inbound_Field_Invoice_DateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Field_Invoice_DateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_field_invoice_date(inputs)
});